import "core-js/modules/es.object.assign.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Fragment } from 'react';
import { FIELDS_TYPES } from '../data';
import { getViewType } from './utils';
export var FieldComponent = function FieldComponent(_ref) {
  var field = _ref.field,
    value = _ref.value,
    size = _ref.size,
    onChange = _ref.onChange;
  var viewType = getViewType(field);
  var _FIELDS_TYPES$viewTyp = FIELDS_TYPES[viewType],
    ViewComponent = _FIELDS_TYPES$viewTyp.component,
    _FIELDS_TYPES$viewTyp2 = _FIELDS_TYPES$viewTyp.props,
    props = _FIELDS_TYPES$viewTyp2 === void 0 ? {} : _FIELDS_TYPES$viewTyp2;
  return React.createElement(Fragment, null, ViewComponent ? React.createElement(ViewComponent, _extends({
    field: field,
    value: value,
    onChange: onChange,
    size: size
  }, props)) : React.createElement("div", null, React.createElement("p", null, "A\xFAn no se he implementado la edici\xF3n de este field")));
};